export { EloDocumentDetailsIcon } from './document-details-icon'
